
import { useUserInfoStore } from "~/stores/userInfoStore"
export default () => {
    const userInfoStore = useUserInfoStore()
    
    return userInfoStore.info?.role || "酒店试用"
}